import { TabContext } from '@mui/lab';

import { Paper } from '@ocx/ui';
import type { OffersCarouselCategory } from '@ocx/data-offers';
import type { AltriaOffersNearbyStatus } from '@ocx/feat-local-offers';

import { OffersCarouselHeader } from './offers-carousel-header.component';
import { OffersCarouselPanelController } from './offers-carousel-panel.controller';

export type OffersCarouselControllerProps = {
  onCategoryChange: (categoryId: string) => void;
  categories: OffersCarouselCategory[];
  selectedCategory: OffersCarouselCategory | null;
  hasAltriaOffersNearby?: AltriaOffersNearbyStatus;
};

export const OffersCarouselController = ({
  categories,
  selectedCategory,
  onCategoryChange,
  hasAltriaOffersNearby,
}: OffersCarouselControllerProps) => {
  if (!categories.length || !selectedCategory) {
    return null;
  }

  return (
    <TabContext value={selectedCategory.id}>
      <Paper data-testid="offers-carousel-container" p={0} sx={{ overflow: 'hidden' }}>
        <OffersCarouselHeader categories={categories} onCategoryChange={onCategoryChange} />
        {categories.map(({ id, offers, banners }) => (
          <OffersCarouselPanelController
            id={id}
            key={id}
            offers={offers}
            banners={banners}
            hasAltriaOffersNearby={hasAltriaOffersNearby}
          />
        ))}
      </Paper>
    </TabContext>
  );
};
